import generateBasicCardBlock from './generateBasicCardBlock';

const generateVideoCard = (title, date, imageUrl, videoId) => {
	const template = generateBasicCardBlock(title, date, imageUrl);

	template.classList.add('modal-marker');
	template.setAttribute('data-target', 'youtube-video');

	template.addEventListener('click', () => {
		document.querySelector('.youtube-video').innerHTML = `<iframe frameborder="0"
		allowfullscreen="1" 
		width="100%" 
		height="100%" 
		src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&amp;controls=1&amp;autohide=1&amp;
		autoplay=1&amp;showinfo=1&amp;rel=0&amp;theme=dark&amp;wmode=opaque"></iframe>`;
	});

	return template;
};

export default generateVideoCard;



// WEBPACK FOOTER //
// ./src/js/about/generateVideoCard.js